<template>
<div class="lesson" :style="{paddingTop: headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true" ref="subHeader"  :showNav="false"></SubHeader>
  <div class="box-line" id="line"></div>
  <div class="lesson-content" :style="{height: `calc(100vh - ${headerHeight}px)`}">
    <div class="classify" v-if="category.length>1">
      <div class="classify-item" v-for="(item, index) of category" :key="item.id" :class="{ 'classify-item_active': item.show }">
        <div class="name" @click="changeAge(item.id)"><p>{{ item.name }}</p><van-icon :name="item.show ? 'arrow-down': 'arrow'"/></div>
        <ul v-if="item.category_list.length" v-show="item.show">
          <li v-for="i in item.category_list" :key="i.id" @click="getList(i.id)" :class="{active:catId == i.id}">{{ i.name }}</li>
        </ul>
      </div>
    </div>
    <div class="list">
      <div class="list-name ellipsis" style="magrin-top: 200px"  v-if="category.length>1 && category[index]">
        {{ category[index].category_list[catIndex] ? category[index].category_list[catIndex].name :  category[index].name}}
      </div>
      <van-list class="scroll-content" v-loading="listLoading" v-if="list.length" v-model="loading" :finished="finished" :finished-text=" list.length>= 7 ? '没有更多了' : '' ">
        <SmallPriceCard v-for="item of list" :key="item.id" @click.native="jumpDetail(item)" :cardData="item"></SmallPriceCard>
      </van-list>
      <div style="margin: 0 auto" class="noMore" v-if="list.length && list.length <7" >没有更多了</div>
      <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
    </div>
  </div>
  <!-- <sub-footer v-if="$route.query.id == 172"></sub-footer> -->
</div>
</template>

<script>
import SmallPriceCard from "@/components/SmallPriceCard";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeaderYingyou";
import LiveCard from "@/components/LiveCard";
import SubFooter from "@/components/YingyouTab";
export default {
  name: "lesson",
  components: {
    SmallPriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    LiveCard,
    SubFooter
  },
  data() {
    return {
      active: 0,
      list: [],
      tag: 1,
      index: 0,
      catIndex: 0,
      category: [],
      loading: false,
      pageLoading: true,
      finished: true,
      more: false,
      ideaNavData: [],
      ideaAllData: [],
      listLoading: false,
      headerHeight:0,
    };
  },
  mounted() {
    this.$nextTick(()=>{
      // console.log('height')
      // console.log(this.$refs.subHeader.$el.offsetHeight)
      this.headerHeight = this.$refs.subHeader.$el.offsetHeight
    })
    window.addEventListener("scroll", this.onLoad);
    this.getCate();
  },
  destroyed() {
    window.removeEventListener("scroll", this.onLoad);
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    // headerHeight() {
    //   return this.$store.state.headerHeight;
    // }
  },
  watch:{
    $route(){
      window.addEventListener("scroll", this.onLoad);
      // this.getData();
    }
  },
  methods: {
    async getCate() {
      console.log('1111111111111')
      this.pageLoading = true;
      let res = await this.$request.jiazhangVIP({
        category_id: this.$route.query.id,
        flat_id: this.plat,
        is_interior: 2,
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.category = res.data.list.map(item=>{
          item.show = false
          return item
        });
        {{ this.category}}
        let id = this.$route.query.id2 || this.category[0].id
        this.changeAge(id)
      } else {
        this.$toast(res.msg);
      }
    },
    changeAge(id){
      if(id == this.ageId) return
      this.ageId = id
      this.index = this.category.findIndex(item=>item.id == id)
      this.category.forEach((item,index)=>{
        if(index==this.index){
          item.show = true
        }else{
          item.show = false
        }
      })
      this.category[this.index].show = true
      this.getList(this.category[this.index].category_list.length? this.category[this.index].category_list[0].id : this.category[this.index].id)
    },
    async getList(id) {
      this.catId = id
      this.catIndex = this.category[this.index].category_list.findIndex(item=>item.id == id)
      this.pageLoading = true;
      let res = await this.$request.tuoyuLessonList({
          category_id: this.catId,
          flat_id: this.plat,
          is_interior: 2,
          
        });
      this.pageLoading = false;
      if (res.code == 0) {
        this.list = res.data.list[0].list[0].list[0]
        console.log(this.list)
      } else {
        this.$toast(res.msg);
      }
    },
    jumpDetail(item) {
      this.$router.push(`./detailYingyou?id=${item.id}`);
    },
    getMore() {
      if (this.more) {
        return;
      }
      this.more = true;
      if (this.menu == 2) {
        axios
          .get(
            `/api/platform/pc/category?flat_id=${this.plat}&page=${this.page}`, {}
          )
          .then((res) => {
            this.more = false;
            console.log(res);
            if (res.code == 0) {
              let list = res.data.category[this.index].goods;
              this.list = this.list.concat(list);
              this.loading = false;
              if (list.length < 10) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.more = false;
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    // console.log(to);
    next();
  },
};
</script>
<style lang="scss">
.lesson{
  .list .van-list{
    
  }
}
</style>
<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  background: #f7f8fa;
  .lesson-content {
    flex: 0 1 auto;
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }

  .lesson-content .classify {
    flex: 0 0 172px;
    height: 100%;
    width: 172px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .lesson-content .list {
    flex: 0 1 auto;
    // min-height: 100vh;
    width: 100%;
    // background: #f7f8fa;
    min-height: calc(100% - 40px);
    overflow: hidden;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    margin: 20px;
    box-sizing: border-box;
    position: relative;
    .noMore{
      position: absolute;
      bottom: 20px;
      text-align: center;
      width: 100%;
      font-size: 28px;
      color: #969799;
    }
  }

  .lesson-content .classify-item {
    // margin: 45px 0 20px;
    .name{
      height: 60px;
      font-size: 26px;
      line-height: 50px;
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background-color: #f4f4f4;
      p{
        flex: 1
      }
    }
    ul{
      padding-bottom: 20px;
      li{
        padding: 20px 10px;
      }
      li.active{
        color: #a7090a;
      }
    }
  }

  .lesson-content .classify-item:last-of-type {
    margin-bottom: 40px;
  }

  .lesson-content .classify-item_active {
    .name{
      background: #a7090a;
      color: #fff;
     
    }
  }

  .lesson-content .list-name {
    padding: 10px 0 30px;
    height: 40px;
    line-height: 40px;
    color: #333;
    font-size: 34px;
    width: 100%;
    flex-shrink: 0;
    background: #f7f8fa;
    box-sizing: content-box;
  }

  .lesson-content .scroll-content {
    width: 100%;
    min-height: calc(100% - 40px);
    height: auto;
    overflow: auto;
    // height: calc(100% - 89px);
    background: #fff;
    // overflow: auto;
    border-radius: 12px;
    padding: 20px 0 ;
    box-sizing: border-box;
    
  }

  .lesson-content .classify-item:last-of-type,
  .lesson-content .card:last-of-type {
    margin-bottom: 100px;
  }
}
</style>

<style lang="scss">
</style>
